module.exports = __webpack_public_path__ + "img/wb3@2x.a27aa6e6.png";